// extracted by mini-css-extract-plugin
module.exports = {"projects":"style-module--projects--aRNW9","heading":"style-module--heading--1O-rc"};